import { ApiResponse } from "interface/response";
import { AxiosApi } from "./index";
import { SalesConfirmation, SalesConfirmationLine } from "interface/sales";
import { FilterOption } from "interface/index";
import { useInfoStore } from "store/error";

export interface SalesConfirmationFilter extends FilterOption {
    buyerLedgerAccountNumber?: string;
    buyerId?: number;
    buyerName?: string;
    vesselLedgerAccountNumber?: string,
    vesselHullId?: number,
    vesselName?: string,
    vesselId?: string,
    salesNumber?: string,
}

export async function getSalesConfirmationApi(filter: SalesConfirmationFilter) {
    const apiUri = "SalesConfirmation/GetList";

    try {
        const salesNote = await AxiosApi.get<ApiResponse<SalesConfirmation[]>>(apiUri, { params: { ...filter } });
        return salesNote.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export async function confirmSalesConfirmationApi({ id, confirmationTypeId, url }: { id: number; confirmationTypeId: number; url?: string }) {
    const apiUri = "SalesConfirmation/Confirm";
    try {
        const salesNote = await AxiosApi.get<ApiResponse<SalesConfirmation[]>>(apiUri, { params: { id, confirmationTypeId, url } });
        return salesNote.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export async function getSalesConfirmationLinesApi({ salesId, confirmationTypeId }: { salesId: number; confirmationTypeId: number }) {
    const apiUri = "SalesConfirmation/Lines";
    try {
        const salesNote = await AxiosApi.get<ApiResponse<SalesConfirmationLine[]>>(apiUri, { params: { salesId, confirmationTypeId } });
        return salesNote.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}
